import { Pipe, PipeTransform } from '@angular/core';
import { CommonService } from 'src/app/shared/services/common.service';
import * as moment from 'moment';

@Pipe({
  name: 'formatRow',
  pure: false,
})
export class FormatRowPipe implements PipeTransform {
  constructor(private commonService: CommonService) {}

  isString(x) {
    return Object.prototype.toString.call(x) === '[object String]';
  }

  isNumber(n) {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
  }

  transform(value: any): any {
    if (!this.isString(value) && this.isNumber(value))
      return this.commonService.ConverTienCoDauPhay2(value);
    if (this.commonService.strIsDateTime(value))
      return moment(value).format('DD/MM/YYYY');
    return value;
  }

  parse(value: any): any {
    return parseFloat(value.replace(/[^0-9]/g, '')) || '';
  }

  transformInput(value: any): any {
    return this.commonService.ConverTienCoDauPhay2(
      value.replace(/[^0-9]/g, '')
    );
  }
}
